import { observer } from 'mobx-react';
import * as React from 'react';

import ReportMenuItem from './controls/report-menu-item';

interface IProps {}

@observer
class ReportsList extends React.Component<IProps> {
  render() {
    return (
      <React.Fragment>
        <ReportMenuItem name="triage" label="Triage" />
        <ReportMenuItem name="initial" label="Initial" />
        <ReportMenuItem name="rfat" label="RFAT" />
        <ReportMenuItem name="discharge" label="Discharge" />
      </React.Fragment>
    );
  }
}

export default ReportsList;
